export default __webpack_public_path__ + "static/media/Dashboard Blue.45a47801.svg";